import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import withModal from '../../../../../../../../../components/global/modal/withModal';
import { getAlbumCustomPrintName } from '../../../../../../../../../util/custom-prints';
import AddedToCartLabel from '../../../PhotoPurchasingOptions/AddedToCartLabel';
import PriceDisplay from '../../../../../../../../../components/global/PriceDisplay';
import Button from '../../../../../../../../../components/global/Button';
import PhotosIcon from '../../../../../../../../../components/icons/PhotosIcon';
import { isAlbumCustomPrintConfigurableInPlace } from '../../helpers';

const propTypes = {
  className: PropTypes.string,
  albumCustomPrint: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string,
    custom_print: PropTypes.shape({
      id: PropTypes.string.isRequired,
      preview_image: PropTypes.shape({
        url: PropTypes.string.isRequired,
      }),
    }).isRequired,
  }).isRequired,
  finalPrice: PropTypes.number,
  oldPrice: PropTypes.number,
  onBundleToggle: PropTypes.func.isRequired,
  inCart: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

const AlbumCustomPrintPreviewModal = ({
  className,
  albumCustomPrint,
  finalPrice,
  oldPrice,
  onBundleToggle,
  inCart,
  onClose,
}) => {
  const classes = classNames({
    'custom-print-preview-modal-content': true,
    [className]: !!className,
  });

  const name = getAlbumCustomPrintName(albumCustomPrint);
  const previewImageSrc = albumCustomPrint.custom_print.preview_image.url;

  return (
    <div className={classes}>
      <img
        src={previewImageSrc}
        alt={`${name} preview`}
        className="custom-print-preview-modal-image"
      />

      {!isAlbumCustomPrintConfigurableInPlace(albumCustomPrint) && (
        <p className="custom-print-preview-modal-photos-note">
          <PhotosIcon size={22} />
          <span className="text-bold">
            You&rsquo;ll be able to pick your {albumCustomPrint.photos_no}{' '}
            favorite pics for your {name.toLowerCase()} after checkout.
          </span>
        </p>
      )}

      <Button
        btnStyle={classNames({
          yellow: !inCart,
          info: inCart,
        })}
        btnSize="lg"
        btnBlock
        className={classNames({
          'text-extra-bold': true,
          'btn-purchase-options-in-cart': inCart,
        })}
        onClick={() => {
          onBundleToggle();

          if (!inCart) {
            onClose();
          }
        }}
        data-testid="btn-album-custom-print-subscription-bundle"
      >
        <span className="pointer-events-none">
          {inCart && <AddedToCartLabel />}
          {!inCart &&
            (isAlbumCustomPrintConfigurableInPlace(albumCustomPrint) ? (
              <Fragment>Select your photos</Fragment>
            ) : (
              <Fragment>
                Add to cart &ndash;{' '}
                <PriceDisplay
                  price={finalPrice}
                  oldPrice={oldPrice}
                  showDiscount
                  animatedStrikethrough
                />
              </Fragment>
            ))}
        </span>
      </Button>

      <Button
        btnBlock
        btnStyle="link"
        onClick={onClose}
        className="text-center"
      >
        Dismiss
      </Button>
    </div>
  );
};

AlbumCustomPrintPreviewModal.propTypes = propTypes;

export default withModal(AlbumCustomPrintPreviewModal, {
  size: 'xs',
  hideHeader: true,
});
